
import React, { useState, useEffect, useRef, useCallback } from 'react';

// SideNav 컴포넌트 (봉안당, 평장묘, 수목장)
function SideNav({ activeSection }) {
  const relocationRef = useRef(null);
  const distributionRef = useRef(null); 
  const bonganRef = useRef(null);
  const pyeongRef = useRef(null);
  const sumokRef = useRef(null);
  // 분양절차
  const [indicatorStyle, setIndicatorStyle] = useState({ top: 0, height: 0 });
  
  const updateIndicator = useCallback(() => {
    let ref = null;
   
    if (activeSection === 'sumokjang') {
      ref = sumokRef.current;
    }
    else if (activeSection === 'bongan') {
      ref = bonganRef.current;
    } else if (activeSection === 'pyeongjangmyo') {
      ref = pyeongRef.current;
    } else if (activeSection === 'sumokjang') {
      ref = sumokRef.current;
    } else if (activeSection === 'distribution-processI') {
      ref = distributionRef.current;
    }else if (activeSection === 'relocation-guide') {
      ref = relocationRef.current;
    }
    if (ref) {
      setIndicatorStyle({
        top: ref.offsetTop,
        height: ref.offsetHeight,
      });
    }
  }, [activeSection]);
  
  useEffect(() => {
    updateIndicator();
  }, [updateIndicator]);
  
  useEffect(() => {
    window.addEventListener('scroll', updateIndicator);
    return () => window.removeEventListener('scroll', updateIndicator);
  }, [updateIndicator]);
  
  return (
    <div className="side-nav">
      <div className="nav-indicator" style={indicatorStyle}></div>
 
      {/* <a ref={bonganRef} href="#bongan" className={`nav-link ${activeSection === 'bongan' ? 'active' : ''}`}>
        봉안당
      </a>
      <a ref={pyeongRef} href="#pyeongjangmyo" className={`nav-link ${activeSection === 'pyeongjangmyo' ? 'active' : ''}`}>
        평장묘
      </a>
      <a ref={sumokRef} href="#sumokjang" className={`nav-link ${activeSection === 'sumokjang' ? 'active' : ''}`}>
        수목장
      </a> */}
      <a ref={distributionRef} href="#distribution-processI" className={`nav-link ${activeSection === 'distribution-processI' ? 'active' : ''}`}> 분양절차</a>
      <a ref={relocationRef} href="#relocation-guide" className={`nav-link ${activeSection === 'relocation-guide' ? 'active' : ''}`}>이장안내</a>
     
    </div>
  );
}
function RelocationInfo() {
  return (
    <div>
      {/* 첫 번째 info-table-description-box (서류 준비 사항) */}
      <div className="info-table-description-box" style= {{ wordBreak: 'keep-all' }}>
        <h2 className="doc-title">서류 준비 사항</h2>
        <p className="doc-text">
          모지개장신고는 이장하기 <strong>14일 이전</strong>(윤달 30일전)에 모지 관할 읍·면·동사무소에서 
          <strong> "개장신고필증"</strong> 서류를 <strong>미리 발급</strong> 준비합니다.
        </p>
        <p className="doc-text">
          개장신고필증을 교부받으면 <strong>화장 14일전</strong>(윤달 30일전)에 화장장에 <strong>예약 접수</strong>(무료대행)
        </p>
        <p className="doc-text">
          개장신고필증 원본 서류는 화장장 이용 시 꼭 필요한 서류입니다.
        </p>
        <p className="doc-text">
          화장장 이용 후 "<strong>화장증명서</strong>" 발급 (납골당에 제출할 서류)
        </p>
        
        <p className="doc-text" style={{ marginTop: '20px', fontStyle: 'italic'}}>
          <strong>※ 참고사항</strong><br/>
          아무리 오래된 분묘일지라도 육탈이 안 된 경우가 있을 수 있습니다.<br/>
          육탈이 안 된 경우는 여러 가지 상황이 있으므로 상세히 알려드리기 어려우나,<br/>
          그런 경우에는 관을 사용해야 하므로 참고하시기 바랍니다.
        </p>
      </div>

      {/* 두 번째 info-table-description-box (개장팀 전국출장 안내) */}
      <div className="info-table-description-box" style= {{ wordBreak: 'keep-all' }}>
        <h2 className="info-title">개장팀 전국출장 안내</h2>
        <p className="info-text">
          개장 작업하시고 납골당을 새로운 장지로 선택하시는 가족분들에게
          전국으로 납골당 <strong>전문 개장팀</strong>을 <strong>합리적인 가격</strong>에 <strong>출장</strong> 보내드립니다.
        </p>
      </div>
    </div>
  );
}
// 이장 안내 컴포넌트
function RelocationGuide() {
  return (
    <div className="relocation-guide" style={{ maxWidth: '1200px', margin: '20 auto', padding: '0 15px'}}>
      <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>▣ 이장 안내 ▣</h2>
      <p style={{ textAlign: 'justify', margin:'2px' }}>
        봉안당 및 분묘 개장은 반드시 적법한 절차를 거쳐야 합니다. 사용기간이 종료된 분묘의 경우, 개장을 통해 합법적으로 유골을 이장할 수 있습니다.
      </p>
      <div className="steps-container" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        {/* 이장 절차 단계 */}
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>01</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>산신제 및 모제</h3>
          <p style={stepContentStyle}>이장을 진행하기 전, 토신제와 제사를 올려 고인을 기립니다.</p>
        </div>
        
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>02</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>기존 분묘 해체</h3>
          <p style={stepContentStyle}>기존 봉안당 또는 묘지를 정리하여 유골을 수습합니다.</p>
        </div>
        
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>03</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>유골 수습</h3>
          <p style={stepContentStyle}>유골이 손상되지 않도록 신중하게 수습하여 준비된 칠성판에 안치합니다.</p>
        </div>
        
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>04</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>염습</h3>
          <p style={stepContentStyle}>유골을 정리한 후, 정성스럽게 염습하여 새로운 장지로 이동할 준비를 합니다.</p>
        </div>
        
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>05</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>유해 새로운 장지 이동</h3>
          <p style={stepContentStyle}>새로운 봉안당 또는 묘지로 유해를 안전하게 이동합니다.</p>
        </div>
        
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>06</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>분묘 조성</h3>
          <p style={stepContentStyle}>최종적으로 고인을 위한 새로운 분묘를 조성하여 이장을 마무리합니다.</p>
        </div>
      </div>
    </div>
  );
}
function OpeningTable() {
  return (
    <div className="info-table-container">
      <table className="info-table">
        <thead>
          <tr>
            <th>구분</th>
            <th>개장 신고</th>
            <th>개장 허가</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>근거 법령</strong></td>
            <td>
              <ul className="info-list">
                <li>장사 등에 관한 법률 제8조</li>
                <li>동법 시행규칙 제2조</li>
              </ul>
            </td>
            <td>
              <ul className="info-list">
                <li>장사 등에 관한 법률 제27조</li>
                <li>동법 시행령 제26조의 2</li>
                <li>동법 시행규칙 제18조</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td><strong>개장 사유</strong></td>
            <td><li>분묘의 연고자가 개장하고자 할 경우</li></td>
            <td><li>승낙 없이 설치된 분묘를 토지 소유자가 개장하고자 할 경우</li></td>
            
          </tr>
          <tr>
            <td><strong>준비 서류</strong></td>
            <td>
              <ul className="info-list">
                <li>기존 분묘의 사진</li>
                <li>개장 신고서 (장사법 시행규칙 별지3호 서식)</li>
              </ul>
            </td>
            <td>
              <ul className="info-list">
                <li>기존 분묘의 사진</li>
                <li>개장 허가신청서 (장사법 시행규칙 별지3호 서식)</li>
                {/* ... */}
              </ul>
            </td>
          </tr>
          {/* 필요 시 다른 행 추가 */}
        </tbody>
      </table>
    </div>
  );
}


// CarouselContent 컴포넌트 (봉안당, 수목장)
function CarouselContent({ title,  images }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Fade out
      setFade(false);
      // 0.5초 후 이미지 교체 후 fade in
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % images.length);
        setFade(true);
      }, 500);
    }, 3000);
    return () => clearInterval(intervalId);
  }, [images.length]);

  return (
    <div className="carousel-content">
      <div className="carousel-header">
        <h3 className="carousel-title">{title}</h3>
      </div>
      <div 
        className="carousel" 
        style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}
      >
        <div className="carousel-image-frame">
          <img src={images[currentIndex]} alt={title} className="carousel-image" />
        </div>
      </div>
      {/* 텍스트 박스 형태의 description */}
    </div>
  );
}
function DistributionProcess() {
  return (
    <div className="distribution-process" style={{ maxWidth: '1200px', margin: '20 auto', padding: '0 15px'}}>
      <h2 style={{ textAlign: 'center', marginBottom: '36px' }}>▣ 분양 절차 ▣</h2>
      <div 
        className="steps-container" 
        style={{
          display: 'flex', 
          justifyContent: 'space-between', 
          flexWrap: 'wrap'
        }}
      >
        {/* STEP 01 */}
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>01</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>분양상담</h3>
          <p style={stepContentStyle}>
            홈페이지 및 전화를 통해 상담 가능합니다.<br/>
            무료 픽업서비스와 <br/>운임관련 보조를 받을 수 있습니다.<br/>
            충남본원 1577-8788<br/>
            충청남도 아산시 외암로 55-15
          </p>
        </div>

        {/* STEP 02 */}
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>02</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>현장방문</h3>
          <p style={stepContentStyle}>
            현장 방문시 저희 픽업서비스를 <br/>이용하시면 편리합니다.
          </p>
        </div>

        {/* STEP 03 */}
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>03</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>선택</h3>
          <p style={stepContentStyle}>
            계약 전, 여러조건 비교선택을 할 수 있습니다.<br/>
            다만 현장에서 예약, 서류작성 및 <br/>잔금계약 연락 주시면 됩니다.
          </p>
        </div>

        {/* STEP 04 */}
        <div className="step" style={stepStyle}>
          <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>04</span></div>
          <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>계약</h3>
          <p style={stepContentStyle}>
            계약시 원하시는 대면 계약을 진행합니다.<br/>
            계약 시, 서류작성 및 신분증이 필요합니다.
          </p>
        </div>

        {/* STEP 05 */}
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>05</span></div>
        <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>잔금납부</h3>
          <p style={stepContentStyle}>
            계약 시 계약서에 적금과 납부액을 주셔야<br/>계약이 진행됩니다.<br/>
            *봉안당사는 항상 보관료와 지적부를 합니다.
          </p>
        </div>

        {/* STEP 06 */}
        <div className="step" style={stepStyle}>
        <div className="step-number" style={stepNumberStyle}><span style={{ color: '#665e5c' }}>STEP</span> <span style={{ color: '#D4AF37' }}>06</span></div>
          <hr style={{ margin: '0px 0', border: 'none', borderTop: '1px solid #ccc'}}/>
          <h3 style={stepTitleStyle}>안치</h3>
          <p style={stepContentStyle}>
            분양 후, 안치단계가 진행됩니다.<br/>
            안치는 직접 오셔서 입관의식을 진행할 수 있고, <br/>저희가 대행해드릴 수도 있습니다.<br/>
            안치 시, 필요한 서류는 주민등록등본, <br/>고인관계 증명서, 화장증명서(화장증명사본 등)입니다.
          </p>
        </div>
      </div>
    </div>
  );
}

// 공통 스타일 객체
const stepStyle = {
  flex: '1 1 30%',
  margin: '0 10px 20px auto',
  border: '1px solid #ccc',
  borderRadius: '8px',
  padding: '20px',
  textAlign: 'center',
  boxSizing: 'border-box'
};

const stepNumberStyle = {
  fontSize: '1.2rem',
  fontWeight: 'bold',
  marginTop: '0px',
  marginBottom: '15px',
  color: '#231918'
};

const stepTitleStyle = {
  fontSize: '1.6rem',
  color: '#231918',
  marginTop: '8px',
  marginBottom: '0px'
};

const stepContentStyle = {
  lineHeight: '1.5',
  fontSize: '1rem',
  marginTop: '8px',
  wordBreak: 'keep-all'
};

// 평장묘 콘텐츠 컴포넌트
function PyeongJangMyoContent() {
  const [activeType] = useState('평장묘&봉안묘');
  
  // 예시 콘텐츠 데이터 (이미지 경로 및 설명은 실제 상황에 맞게 수정)
  const contentData = {
    '평장묘&봉안묘': {
      description: '아산 메모리얼 파크는 무엇보다 편안한 휴식을 제공하기 위해 제작되었습니다. 동시에, 제례음식을 올릴 수 있으며 헌화도 드릴 수 있는 실용성도 갖추었습니다. 가격도 저렴하여 가장 합리적인 선택의 개인묘입니다.',
      images: ['/img/pyeongjangmyo1.jpg', '/img/pyeong_coupleA1.jpg','/img/pyeongjangmyo.jpg','/img/pyeongjangmyo2.jpg']
    }
  };
  
  const { description, images } = contentData[activeType];
  
  return (
    <div className="pyeong-content">
      
      <CarouselContent title={activeType} description={description} images={images} />
  
    </div>
  );
}

function BonganPriceTable() {
  return (
    <div className="price-table-container">
      <h4>봉안당 가격 (단위: 만원)</h4>
      <table className="price-table">
        <thead>
          <tr>
            <th>구분</th>
            <th>개인단</th>
            <th>부부단</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>8단</td><td>200</td><td>400</td></tr>
          <tr><td>7단</td><td>400</td><td>800</td></tr>
          <tr><td>6단</td><td>500</td><td>1,000</td></tr>
          <tr><td>5단</td><td>700</td><td>1,400</td></tr>
          <tr><td>4단</td><td>700</td><td>1,400</td></tr>
          <tr><td>3단</td><td>450</td><td>900</td></tr>
          <tr><td>2단</td><td>350</td><td>700</td></tr>
          <tr><td>1단</td><td>300</td><td>600</td></tr>
        </tbody>
      </table>

      <h4>봉안당 관리비 / 가입기간</h4>
      <table className="price-table">
        <thead>
          <tr>
            <th>구분</th>
            <th>1년 관리비</th>
            <th>최초 가입기간</th>
            <th>재계약기간</th>
            <th>최초 납입금</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>개인단</td><td>50,000</td><td>5년</td><td>5년</td><td>250,000</td></tr>
          <tr><td>부부단</td><td>100,000</td><td>5년</td><td>5년</td><td>500,000</td></tr>
        </tbody>
      </table>
    </div>
  );
}

function BongMyoPyungPriceTable() {
  return (
    <div className="price-table-container">
      <h4>봉안묘 & 평장묘 가격 (단위: 만원)</h4>
      <table className="price-table">
        <thead>
          <tr>
            <th>구분</th>
            <th>가격</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>평장묘 개인묘 (450×450×500)</td><td>700</td></tr>
          <tr><td>봉안묘 개인묘</td><td>700</td></tr>
          <tr><td>봉안묘 부부묘</td><td>1,100</td></tr>
          <tr><td>봉안묘 4위 A형</td><td>1,400</td></tr>
          <tr><td>봉안묘 4위 B형</td><td>1,200</td></tr>
          <tr><td>6위 ~ 24위 (대가족/종중)</td><td>상담 후 가격합의</td></tr>
        </tbody>
      </table>

      <h4>봉안묘 & 평장묘 관리비 / 가입기간</h4>
      <table className="price-table">
        <thead>
          <tr>
            <th>구분</th>
            <th>1년 관리비</th>
            <th>최초 가입기간</th>
            <th>재계약기간</th>
            <th>최초 납입금</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>평장묘 개인묘</td><td>50,000</td><td>5년</td><td>5년</td><td>250,000</td></tr>
          <tr><td>봉안묘 개인묘</td><td>50,000</td><td>5년</td><td>5년</td><td>250,000</td></tr>
          <tr><td>봉안묘 부부묘</td><td>100,000</td><td>5년</td><td>5년</td><td>500,000</td></tr>
          <tr><td>1위</td><td>50,000</td><td>-</td><td>-</td><td>250,000</td></tr>
          <tr><td>2위</td><td>100,000</td><td>-</td><td>-</td><td>500,000</td></tr>
          <tr><td>4위</td><td>150,000</td><td>-</td><td>-</td><td>750,000</td></tr>
          <tr><td>8위</td><td>200,000</td><td>-</td><td>-</td><td>1,000,000</td></tr>
          <tr><td>12~16위</td><td>250,000</td><td>-</td><td>-</td><td>1,250,000</td></tr>
          <tr><td>24위</td><td>300,000</td><td>-</td><td>-</td><td>1,500,000</td></tr>
        </tbody>
      </table>
    </div>
  );
}
function Services() {
  const [activeSection, setActiveSection] = useState('#bongan');
  
  useEffect(() => {
    const sections = document.querySelectorAll('section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.getAttribute('id'));
          }
        });
      },
      { threshold: 0.5 }
    );
    
    sections.forEach(section => observer.observe(section));
    
    return () => observer.disconnect();
  }, []);
  
  return (
    <div className="memorial-page">
      <SideNav activeSection={activeSection} />
      
      
       <div className="memorial-content">
       {/*         <div className="spacer-medium"></div>
        <section id="bongan">
        
          <CarouselContent 
            title="봉안당" 
            images={['/img/bongan.jpg','/img/bongan2.jpg', '/img/bongan3.jpg']}
          />
      <div className="spacer-small"></div>
        </section>
        
        <section id="pyeongjangmyo">
          <PyeongJangMyoContent />
       
        </section>
        <div className="spacer-small"></div>
        <section id="sumokjang">
          <CarouselContent 
            title="수목장" 
            description="거산 시루봉에서 이어지는 정기를 그대로 받은 대자연속의 수목장. 매일 정성껏 돌보는 수목은 고인의 평온과 안식을 기원하여 친황경 공원묘역으로 가꾸고 있으며, 개인 및 가족묘로 경제적인 장례가 가능합니다" 
            images={['/img/sumokjang1.jpg', '/img/sumokjang2.jpg']}
          />
      </section> */}
      <div className="spacer-small"></div>
        <section id="distribution-processI">
          <DistributionProcess />
        </section>
        <div className="spacer-small"></div>
        <section id="relocation-guide">
        <RelocationGuide />
          <div className="spacer-small"></div>
        <OpeningTable />  {/* ← 표 추가 */}
        <div className="spacer-small"></div>
          <RelocationInfo />
        <div className="spacer-medium"></div>
        </section>
      </div>
    </div>
  );
}
export default Services;